import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/announce-hanging.svg'
import _imports_1 from '@/app/ui/assets/svg/sync-hanging.svg'
import _imports_2 from '@/app/ui/assets/svg/scan-hanging.svg'
import _imports_3 from '@/app/ui/assets/svg/history-hanging.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-089a00e3")

_pushScopeId("data-v-089a00e3")
const _hoisted_1 = { class: "flex gap-6 justify-between items-center" }
const _hoisted_2 = { class: "text-black-lp-200" }
const _hoisted_3 = { class: "text-xl font-bold" }
const _hoisted_4 = { class: "flex gap-1" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "announce-hanging"
}, null, -1)
const _hoisted_6 = { class: "text-xs" }
const _hoisted_7 = { class: "text-black-lp-200 font-bold text-sm" }
const _hoisted_8 = { class: "text-black-lp-200 font-bold text-sm" }
const _hoisted_9 = { class: "text-black-lp-200 font-bold text-sm" }
const _hoisted_10 = { class: "mb-2 flex text-green-lp-100 gap-1 text-sm" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "sync-hanging"
}, null, -1)
const _hoisted_12 = { class: "font-semibold mr-0.5" }
const _hoisted_13 = { class: "italic" }
const _hoisted_14 = { class: "flex gap-2 justify-end" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4 mr-2"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "mr-2"
}, null, -1)
const _hoisted_17 = { class: "grid grid-cols-4 gap-2" }
const _hoisted_18 = { class: "flex flex-col gap-2 px-3" }
const _hoisted_19 = { class: "flex text-sm text-gray-lp-300 items-center justify-center" }
const _hoisted_20 = { class: "class-bottom-card text-black-lp-200 px-3 py-1 rounded-2xl flex justify-center items-center text-xs" }
const _hoisted_21 = { class: "text-sm font-bold" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: "p-3 flex flex-col gap-y-3",
    rounded: "2xl"
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("dashboard.hangingBkd.title")), 1),
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.$t("dashboard.hangingBkd.sttHanging")) + " ", 1),
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("dashboard.hangingBkd.days")), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("dashboard.hangingBkd.on")) + " ", 1),
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("dashboard.hangingBkd.statuses")), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("dashboard.hangingBkd.mustBe")) + " ", 1),
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("dashboard.hangingBkd.sti")) + ". ", 1)
            ])
          ])
        ]),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("dashboard.hangingBkd.lastSync")), 1),
            _createVNode("span", _hoisted_13, _toDisplayString(_ctx.formatDate(_ctx.data.lastSync, "DD MMMM YYYY, HH:mm")), 1)
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("button", {
              id: "btn-search-stt-hanging-bkd-pos",
              class: "flex items-center text-sm bg-red-lp-100 text-white px-4 py-2 rounded-md font-semibold",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/cari-stt/scan')))
            }, [
              _hoisted_15,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("dashboard.hangingBkd.searchStt")), 1)
            ]),
            _createVNode("button", {
              id: "btn-history-hanging-bkd-pos",
              class: "flex items-center text-sm bg-white text-red-lp-100 px-4 py-2 rounded-md font-semibold border border-red-lp-100",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/dashboard/history-hanging-bkd-pos')))
            }, [
              _hoisted_16,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("dashboard.hangingBkd.history")), 1)
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cardData, (c, i) => {
          return (_openBlock(), _createBlock("div", {
            key: i,
            class: "flex flex-col gap-2"
          }, [
            _createVNode("div", {
              class: ["flex flex-col pt-3 gap-2 rounded-2xl justify-between bg-white border border-b-0 border-gray-lp-1400", !i ? 'class-activity' : '']
            }, [
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _createVNode("img", {
                    src: c.icon,
                    alt: c.alt,
                    class: "mr-2"
                  }, null, 8, ["src", "alt"]),
                  _createVNode("p", {
                    class: "text-black-lp-200 px-1",
                    innerHTML: c.label
                  }, null, 8, ["innerHTML"])
                ]),
                _createVNode("div", {
                  class: ["flex justify-center font-bold h-16 items-center", 
                !i ? 'text-red-lp-2000 text-5xl' : 'text-black-lp-200 text-34px'
              ]
                }, _toDisplayString(c.pending), 3)
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("span", _hoisted_21, _toDisplayString(c.done), 1),
                _createTextVNode("/" + _toDisplayString(c.total) + " " + _toDisplayString(!i
                ? _ctx.$t("dashboard.hangingBkd.activityDone")
                : _ctx.$t("dashboard.hangingBkd.processedToday")), 1)
              ])
            ], 2)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
})